//Margin conventions
var margin = {top: 5, right: 128, bottom: 22, left: 53};

var widther = d3.select(".gia-chart").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 320 - margin.top - margin.bottom;

//Parses date for correct time format
var parseDate = d3.time.format("%Y").parse;  

//Comma formater
var format = d3.format("0,000");  

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
	.attr("width", width + margin.left + margin.right)
	.attr("height", height + margin.top + margin.bottom)
	.append("g")
	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
var xScale = d3.time.scale()
  .range([0, width]);

//Creates the yScale
var yScale = d3.scale.linear()
  .range([height, 0]);

//Defines the y axis styles
var yAxis = d3.svg.axis()
	.scale(yScale)
  .tickSize(-width)
  .tickPadding(6)
  .ticks(5)
  .tickFormat(function(d) { return format(d); })
	.orient("left");

//Defines the y axis styles
var xAxis = d3.svg.axis()
	.scale(xScale)
  .tickPadding(6)
	.orient("bottom")
  .ticks(4)
  .tickFormat(d3.time.format("%Y")); 

//line function convention (feeds an array)
var line = d3.svg.line()
  .defined(function(d) { return d.jobs != 0; })
  .x(function(d) { return xScale(d.date); })
  .y(function(d) { return yScale(d.jobs); }); 

//Loads the data
d3.csv("data/solarjobs.csv", ready);

function ready(err, data) {

	if (err) throw "error loading data";

	//FORMAT data
	data.forEach(function(d) {
		d.jobs = +d.jobs;
    d.date = parseDate(d.date);
	});
	
	//Organizes the data	
  data.sort(function(a,b) { return a.date - b.date; });
  var maxY = d3.max(data, function(d) { return d.jobs; });
  var maxX = d3.max(data, function(d) { return d.date; });

  //Nest the data
  var dataByCategory = d3.nest()
    .key(function(d) { return d.sector;})
    .entries(data);

  console.log(dataByCategory);  

  //Defines the xScale max
  xScale.domain(d3.extent(data, function(d) { return d.date; }));

  //Defines the yScale max
  yScale.domain([0, 150000]);

	//Appends the y axis
	var yAxisGroup = svg.append("g")
		.attr("class", "y axis")
		.call(yAxis)
		.selectAll("g")
		.classed("g-baseline", function(d) {return d == 0});

	//Appends the x axis		
	var xAxisGroup = svg.append("g")
		.attr("class", "x axis")
		.attr("transform", "translate(0," + height + ")")
		.call(xAxis);   

  //Binds the data to the line
  var drawline = svg.selectAll(".cat-path")
    .data(dataByCategory)
    .enter()
    .append("path")
    .attr("class", "cat-path")
    .attr("d", function(d) { return line(d.values) })
    .classed("install-line", function(d) { return d.key == "Installation"; })
    .classed("manu-line", function(d) { return d.key == "Manufacturing"; })
    .classed("sales-line", function(d) { return d.key == "Sales & Distribution"; })
    .classed("project-line", function(d) { return d.key == "Project Development"; }) 
    .classed("other-line", function(d) { return d.key == "Other"; }); 

  //Append labels  
  var installlabel = svg.append("text")
      .text("Installation")
      .attr("class", "install-label")
      .attr("x", width/1)
      .attr("y", height/10)
      .attr("transform", "translate(5,0)");   

  var manulabel = svg.append("text")
      .text("Manufacturing")
      .attr("class", "manu-label")
      .attr("x", width/1)
      .attr("y", height/1.39)
      .attr("transform", "translate(5,0)");    

  var saleslabel = svg.append("text")
      .text("Sales & Distribution")
      .attr("class", "sales-label")
      .attr("x", width/1)
      .attr("y", height/1.21)
      .attr("transform", "translate(5,0)");

  var projectlabel = svg.append("text")
      .text("Project Development")
      .attr("class", "project-label")
      .attr("x", width/1)
      .attr("y", height/1.29)
      .attr("transform", "translate(5,0)");  

  var otherlabel = svg.append("text")
      .text("Other")
      .attr("class", "other-label")
      .attr("x", width/1)
      .attr("y", height/1.12)
      .attr("transform", "translate(5,0)");                  	

//RESPONSIVENESS
  d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 5, right: 128, bottom: 22, left: 53};

    var newWidther = d3.select(".gia-chart").node().clientWidth;

    var newWidth = newWidther - newMargin.left - newMargin.right;

    //Change the width of the svg
    d3.select("svg")
      .attr("width", newWidth + newMargin.left + newMargin.right);

    //Change the xScale
    xScale
      .range([0, newWidth]);

    //Update the line
    line = d3.svg.line()
      .defined(function(d) { return d.jobs != 0; })
      .x(function(d) { return xScale(d.date); })
      .y(function(d) { return yScale(d.jobs); }); 

    d3.selectAll('.cat-path')
      .attr("d", function(d) { return line(d.values) }) 

    //Updates xAxis
    d3.selectAll(".x.axis")
         .call(xAxis);     

    //Updates ticks
    xAxis
      .scale(xScale)
      .ticks(4);

    //Updates yAxis
    d3.selectAll(".y.axis")
      .call(yAxis); 

    yAxis
      .tickSize(-newWidth);

    installlabel
      .attr("x", newWidth/1);  

    manulabel
      .attr("x", newWidth/1); 

    saleslabel
      .attr("x", newWidth/1); 

    projectlabel
      .attr("x", newWidth/1);     

    otherlabel
      .attr("x", newWidth/1);      
  };

}